<template>
  <div class="w-auto inline-flex items-center gap-1" v-if="percentage">
    <span
      v-if="!withoutIcon"
      class="icon-chevron-top text-lg"
      :class="[
        checkProfit(percentage)?.textColor,
        checkProfit(Number(profit))?.position,
      ]"
    />
    <div
      class="text-sm font-semibold font-interDisplay"
      :class="checkProfit(percentage)?.textColor"
    >
      {{ formatMoneyExact(percentage, 2) }}%
    </div>
  </div>
</template>

<script setup lang="ts">
import { checkProfit, formatMoneyExact } from "@/utils";
interface Props {
  profit?: string | undefined;
  percentage?: number;
  withoutIcon: boolean;
}
withDefaults(defineProps<Props>(), {
  withoutIcon: false,
});
</script>

<style scoped></style>
